import { createDecipheriv } from '@ravshansbox/browser-crypto';

export const decrypt = (encrypted) => {
  try {
    const decipher = createDecipheriv(
      'aes-256-cbc',
      process.env.REACT_APP_AES_ENC_KEY,
      process.env.REACT_APP_AES_IV
    );
    let decrypted = decipher.update(encrypted, 'base64', 'utf8');
    return decrypted + decipher.final('utf8');
  } catch (error) {
    return encrypted;
  }
};
